/* eslint-disable import/prefer-default-export */
import { track } from "common/utils/mixpanel/tracker";
import {
  trackRudderstackImageUploadStarted,
  trackRudderstackImageRemoved,
  trackRudderstackImageUploadCompleted
} from "common/utils/rudderstack/tracker";
import { getPageSourceParam } from "components/jiffy/product-details/customizable-made-page-utils";

export const trackUploadInitiated = (location, mode, file) => {
  const source = getPageSourceParam();

  track("made_pdp_upload_initiated", { location, mode, source });

  trackRudderstackImageUploadStarted({
    catalog_number: document.querySelector(".js-quantity-form-input")?.dataset?.catalogNumber,
    location: "print_order_builder",
    file_type: file.type,
    file_size: file.size,
    file_name: file.name,
    dpi: 300,
    business_line: "Print",
    artworks_count: 1,
    source
  });
};

export const trackUploadSuccess = (location, file, artwork) => {
  const source = getPageSourceParam();

  track("made_pdp_upload_success", { location, source });

  trackRudderstackImageUploadCompleted({
    location: "print_order_builder",
    file,
    artwork,
    dpi: 300,
    business_line: "Print",
    artworks_count: 1,
    source
  });
};

export const trackRemoveImage = ({ location, filetype, filesize, filename }) => {
  const source = getPageSourceParam();

  track("made_pdp_remove_image", { location, source });

  trackRudderstackImageRemoved({
    file_name: filename,
    file_type: filetype,
    file_size: filesize,
    location: "print_order_builder",
    business_line: "Print",
    artworks_count: 1,
    source
  });
};

export const trackCustomPlacementInteraction = payload => {
  track("made_pdp_custom_placement_interaction", { ...payload, source: getPageSourceParam() });
};
